import ApiClient from ".."

// In DTOs
import ClientGetListIn from "../../dtos/in/ClientGetListIn"
import ClientPutIn from "../../dtos/in/ClientPutIn"
import ClientPostNoteIn from "../../dtos/in/ClientPostNoteIn"

// Out DTOs
import ClientGetListOut from "../../dtos/out/ClientGetListOut"
import CoachGetClientOut from "../../dtos/out/CoachGetClientOut"
import ClientGetCheckGroupCoachingOut from "../../dtos/out/ClientGetCheckGroupCoachingOut"
import GenericOut from "../../dtos/out/GenericOut"
import ClientGetNoteOut from "../../dtos/out/ClientGetNoteOut"
import CoachPatchClientCreditsIn from "../../dtos/in/CoachPatchClientCreditsIn"

export class ClientEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/client"

  /**
   * Retrieves a client's (user's) details.
   */
  async get(userId: number) {
    return this.client.get<CoachGetClientOut>(ClientEndpoints.BASE_URL, `/${userId}`)
  }

  /**
   * Retrieves a list of clients (users) with filters, ordering, and pagination.
   */
  async getList(payload: ClientGetListIn) {
    return this.client.get<ClientGetListOut>(ClientEndpoints.BASE_URL, "/", payload)
  }

  /**
   * Retrieves a list of clients for a coach with filters, ordering, and pagination.
   */
  async getListForCoach(coachId: number, payload: ClientGetListIn) {
    return this.client.get<ClientGetListOut>(ClientEndpoints.BASE_URL, `/coach/${coachId}`, payload)
  }

  /**
   * Checks for an active group coaching zoom registration.
   */
  async checkGroupCoaching(userId: number) {
    return this.client.get<ClientGetCheckGroupCoachingOut>(
      ClientEndpoints.BASE_URL,
      `/${userId}/group-coaching/registration`
    )
  }

  /**
   * Unregisters client from group coaching
   */
  async patchGroupCoachingUnregister(userId: number) {
    return this.client.patch<GenericOut>(ClientEndpoints.BASE_URL, `/${userId}/group-coaching/unregister`, null)
  }

  /**
   * Registers client with active subscription into group coaching
   */
  async postGroupCoachingRegister(userId: number) {
    return this.client.post<GenericOut>(ClientEndpoints.BASE_URL, `/${userId}/group-coaching/register`, null)
  }

  /**
   * Gets client note
   * @param userId
   */
  async getClientNote(userId: number) {
    return this.client.get<ClientGetNoteOut>(ClientEndpoints.BASE_URL, `/${userId}/note`)
  }

  /**
   * Creates or updates the client note
   * @param userId
   * @param payload - ClientPostNoteIn
   */
  async postClientNote(userId: number, payload: ClientPostNoteIn) {
    return this.client.post<GenericOut>(ClientEndpoints.BASE_URL, `/${userId}/note`, payload)
  }

  /**
   * Updates the provided client's data.
   */
  async put(userId: number, payload: ClientPutIn) {
    return this.client.put<GenericOut>(ClientEndpoints.BASE_URL, `/${userId}`, payload)
  }

  async putCredits(userId: number, payload: CoachPatchClientCreditsIn) {
    return this.client.put<GenericOut>(ClientEndpoints.BASE_URL, `/${userId}/credits`, payload)
  }
}
